import { PlanProvider } from '@blocs.paywall';
import { gqlPlanTermEnum } from '@minecraft.graphql-types';

type PaidTrialSubscription = {
  trialEndsAt?: string | null;
  plan?: {
    isBasePlan?: boolean | null;
    provider?: string | null;
    term?: { code?: string | null } | null;
  } | null;
} | null;

const PAID_TRIAL_TERMS = [gqlPlanTermEnum.ANNUAL, gqlPlanTermEnum.MONTHLY];

/**
 * Annual or monthly subscribers whose paid trial has not ended.
 * Free / registration plans are base plans and use a different headshots modal.
 */
export const isPaidTrialSubscriber = (subscription?: PaidTrialSubscription): boolean => {
  const plan = subscription?.plan;
  const trialEndsAt = subscription?.trialEndsAt;

  if (!trialEndsAt || !plan || plan.isBasePlan || (plan.provider as PlanProvider | null) === PlanProvider.APPLE) {
    return false;
  }

  if (!PAID_TRIAL_TERMS.includes(plan.term?.code as gqlPlanTermEnum)) {
    return false;
  }

  const trialEnd = new Date(trialEndsAt);

  return !Number.isNaN(trialEnd.getTime()) && trialEnd.getTime() > Date.now();
};
